/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createTeamBodyDescriptionOneMax = 2000;

export const CreateTeamBody = zod.object({
  name: zod.string(),
  description: zod
    .union([zod.string().max(createTeamBodyDescriptionOneMax), zod.null()])
    .optional(),
});

export type CreateTeamBody = zod.input<typeof CreateTeamBody>;
export type CreateTeamBodyOutput = zod.output<typeof CreateTeamBody>;
